import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const isMobile = false // window.navigator.userAgent.match(/iphone|android|mobile|ipad/ig)

const routes = [
  {
    path: '/', name: 'home', component: () => import('@/views/home.vue'),
    beforeEnter: (to, from, next) => isMobile ? next('/support') : next()
  },
  {
    path: '/support', name: 'support', component: () => import('@/views/mobile.vue'),
    beforeEnter: (to, from, next) => !isMobile ? next('/') : next()
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
